<template>
    <div class="preloader-wrap">
        <div class="box">
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  mounted () {
    this.getType;
  },
  watch: {
  },
  computed: {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/color';

$c-white: #fff;
$c-black: #000;
$ani-dur: 3s;
$size: 50px;

@mixin fill {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.preloader-wrap {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    &:before {
        content: '';
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #fff;
        opacity: 0.5;
    }
}

.cube {
  position: absolute;
  width: 1em;
  height: 1em;
  background: #00bcad;
  animation: move $ani-dur ease-in-out infinite;
  // animation-play-state: paused;
  transform-style: preserve-3d;
//   box-shadow: 5em 5em .3em .1em #404040;
  
  &::before,
  &::after {
    content: '';
    @include fill;
  }

  &::before {
    background-color: #009387;
    transform-origin: 100% 100%;
    transform: rotateY(-90deg);
  }

  &::after {
    background-color: $active;
    transform-origin: 0% 100%;
    transform: rotateX(90deg);
  }
  
  @for $i from 1 through 4 {
    &:nth-of-type(#{$i}) {
      animation-delay: $ani-dur * ($i / 4 - 4);
    }
  }
  
  @keyframes move {
    0%,
    87.5%,
    100%  { transform: translate(1em, 0em); }
    12.5% { transform: translate(2em, 0em); }
    25%   { transform: translate(2em, 1em); }
    37.5%, 
    50%   { transform: translate(1em, 1em); }
    62.5% { transform: translate(0em, 1em); }
    75%   { transform: translate(0em, 0em); }
  }
}

.box {
  width: 3em;
  height: 2em;
  // margin: 30vmin auto;
  font-size: $size;
  transform-style: preserve-3d;
  transform: translateZ(100px) rotateX(60deg) rotateZ(45deg);
  
  &:hover * { animation-play-state: paused; }
  &:active * { animation-play-state: running; }
}

/// reset
*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  height: 100%;
}

body {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  margin: 0;
  line-height: 1.4;
}

</style>